export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/nav-626aec707f978b0e0f8d6bc600bbee10.png";